<template>
  <td class="align-top">
    <span class="font-semibold mr-1">{{ format.container }}</span>
  </td>
  <td class="align-top">
    <span
      v-if="format.label"
      class="uppercase text-white font-black bg-gray-700 px-2 py-1 rounded-md mr-1"
    >
      {{ format.label }}
    </span>
  </td>
  <td
    class="flex flex-row md:flex-col lg:flex-row items-center gap-2 align-top"
  >
    <span class="italic">{{ format.resolution }}</span>
    <span
      v-if="format.highlightLabel"
      class="whitespace-nowrap uppercase !text-sm text-white font-bold bg-green-400 px-2 py-1 rounded-md"
    >
      {{ format.highlightLabel }}
    </span>
  </td>
</template>

<script setup>
  const _props = defineProps({
    format: Object,
  })
</script>

<style lang="scss" scoped>
  td {
    @apply py-2;

    span {
      @apply text-lg;
    }
  }
</style>
